import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAdvDqrL2p877xNqqtfHaEobLLPcaPnKE8",
  authDomain: "dazzling-scheme-419800.firebaseapp.com",
  databaseURL: "https://dazzling-scheme-419800-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dazzling-scheme-419800",
  storageBucket: "dazzling-scheme-419800.firebasestorage.app",
  messagingSenderId: "673000871790",
  appId: "1:673000871790:web:e89ef790fc2351131b537f",
  measurementId: "G-Q2NK0KXTZ8"
};
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;